export default {
  1: 'Portero',
  2: 'Defensa Central',
  3: 'Lateral por izquierda',
  4: 'Lateral por derecha',
  5: 'Volante por izquierda',
  6: 'Volante por derecha',
  7: 'Volante defensivo',
  8: 'Volante ofensivo',
  9: 'Delantero',
};
